import { Component, input, Input, output, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BudgetItemComponent } from './budget-item/budget-item.component';
import { BudgetBannerComponent } from './budget-banner/budget-banner.component';
import { BudgetTotalComponent } from './budget-total/budget-total.component';
import { IItemBudget } from '@core/interface';

@Component({
  selector: 'agenda-customer-ui-budget-final',
  standalone: true,
  imports: [CommonModule, BudgetTotalComponent, BudgetItemComponent, BudgetBannerComponent],
  templateUrl: './budget-final.component.html',
  styleUrls: ['./budget-final.component.scss'],
})
export class BudgetFinalComponent {
  @Input() budgetList: IItemBudget[] = [];
  @Input() discountList: IItemBudget[] = [];
  total = input.required<string>();
  oldTotal = input.required<string>();
  hasOnlinePayment = input.required<boolean>();
  hasOnRequest = input.required<boolean>();
  totalSubtitle = input<string>('');
  alreadyPaidItem = input<IItemBudget | null>(null);
  openModal = output<boolean>();

  isExpanded = false;

  constructor(private renderer: Renderer2) {}

  toggleDrawer() {
    this.isExpanded = !this.isExpanded;
    this.renderer.setStyle(document.body, 'overflow',  this.isExpanded ? 'hidden' : 'auto');
  }
}
